





































































































































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import brandModule from '../../store/modules/brand.module';
import Admin from '../../common/model/Admin';
import { eventBus } from '../../main';
import { SHOW_SNACKBAR } from '../../common/constants';
import adminModule from '../../store/modules/admin.module';
import errorModule from '../../store/modules/error.module';
import Tag from '../../common/model/Tag';
import { BroadcastEvent } from '../../common/types';

const initialEvent: BroadcastEvent = {
  title: '',
  description: '',
  meeting_id: '',
  meeting_passcode: '',
  tags: [],
  start_time: undefined,
  end_time: undefined,
};

@Component({
  components: {},
})
export default class AdminMeetingPage extends Vue {
  removeUserTitle = '';

  removeUserBody =
    'By removing this user, they will no longer have access to the admin portal or the assets for the brand.';

  search = '';

  headers = [
    { text: 'Title', value: 'title' },
    { text: 'Start Time', value: 'display_start_time' },
    { text: 'End Time', value: 'display_end_time' },
    { text: 'Meeting ID', value: 'meeting_id' },
    { text: 'Passcode', value: 'meeting_passcode' },
    { text: 'Attendees', value: 'total_attendees' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  deleteBroadcastDialog = false;

  scheduleBroadcastDialog = false;

  brandModule = brandModule;

  isEditDialog = false;

  event: BroadcastEvent = initialEvent;

  get broadcasts() {
    if (!brandModule.brand) {
      return [];
    }
    const broadcasts: Array<any> = [];
    for (
      let meetingIndex = 0;
      meetingIndex < brandModule.meetings.length;
      meetingIndex += 1
    ) {
      const broadcast: any = brandModule.meetings[meetingIndex];
      const startDate = new Date(broadcast.start_time);
      const endDate = new Date(broadcast.end_time);
      console.log(broadcast);
      broadcast.display_start_time = `${startDate.getMonth()}/${startDate.getDate()}/${startDate.getFullYear()} ${this.formatTime(
        startDate,
      )}`;
      broadcast.display_end_time = `${endDate.getMonth()}/${endDate.getDate()}/${endDate.getFullYear()} ${this.formatTime(
        endDate,
      )}`;
      broadcast.total_attendees = broadcast.attendees.length;
      broadcasts.push(broadcast);
    }

    return broadcasts;
  }

  cancelDialog(): void {
    this.scheduleBroadcastDialog = false;
    this.event = initialEvent;
    this.isEditDialog = false;
  }

  async scheduleBroadcast(): Promise<void> {
    this.scheduleBroadcastDialog = true;
  }

  async editBroadcastEvent(event): Promise<void> {
    this.event = event;
    this.isEditDialog = true;
    this.scheduleBroadcastDialog = true;
  }

  async createBroadcastEvent(): Promise<void> {
    if (
      (!this.event.start_time && !this.event.end_time)
      || !this.event.meeting_id
    ) {
      eventBus.$emit(
        SHOW_SNACKBAR,
        'Your broadcast must include a start time, end time, and meeting ID.',
      );
      return;
    }
    if (!brandModule.brand) {
      return;
    }
    this.event.brand_id = brandModule.brand.id;
    if (this.isEditDialog) {
      await brandModule.updateMeeting(this.event);
    } else {
      await brandModule.createMeeting(this.event);
    }
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    this.scheduleBroadcastDialog = false;
    this.isEditDialog = false;
    this.event = initialEvent;
  }

  async deleteConfirmed(): Promise<void> {
    console.log('Delete');
  }

  formatTime(time: Date): string {
    const minutes = (time.getMinutes() < 10 ? '0' : '') + time.getMinutes();
    let hours = time.getHours() - 12;
    let timeOfDay = 'PM';
    if (time.getHours() < 12) {
      timeOfDay = 'AM';
      hours = time.getHours();
    }

    return `${hours}:${minutes} ${timeOfDay}`;
  }
}
